import { IContainer, ILazyBinder, injectContainer } from './container';

export interface IKVStorage {
    getItem: (key: any) => Promise<any>;
    setItem: (key: any, value: any) => Promise<void>;
    removeItem: (key: any) => Promise<void>;
    clear: () => Promise<void>;
    length: () => Promise<any>;
}

const TYPES = {
    IKVStorage: Symbol.for('IKVStorage'),
};

export function injectKVStorage(container: IContainer = injectContainer()): Promise<IKVStorage> {
    return container.get<ILazyBinder<IKVStorage>>(TYPES.IKVStorage)();
}

export function bindKVStorage(
    val: ILazyBinder<IKVStorage>,
    container: IContainer = injectContainer(),
) {
    return container.bind<ILazyBinder<IKVStorage>>(TYPES.IKVStorage, val);
}
